import { companyIcon } from "helpers/dotenv";
import "modules/auth/auth.css";
import { Spinner } from "modules/common/components";
import PropTypes from "prop-types";
import React from "react";
import { Col } from "react-bootstrap";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import APIHandler from "../../../../common/dataset/api";
import { Authlayout } from "../styles";
import CommonManager from "../../../../../helpers/common";

const propTypes = {
  history: PropTypes.object,
  content: PropTypes.element,
  currentUser: PropTypes.object,
};

const commonManger = new CommonManager();

const srcLogo = commonManger.isValidUrl(companyIcon) ? companyIcon : `/images/${companyIcon}`;

class AuthLayout extends React.Component {
  constructor(props) {
    super(props)
    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.state = {
      loading: true,
      redirect: false,
      isMediumScreen: false,
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  handleWindowResize() {
    if (window.innerWidth <= 991) {
      this.setState({ isMediumScreen: true, isSmallScreen: false })
      return;
    }
    else if (window.innerWidth <= 540) {
      this.setState({ isSmallScreen: true, isMediumScreen: false })
      return;
    }
    this.setState({ isMediumScreen: false, isSmallScreen: false })
  }

  componentDidMount() {
    const token = localStorage.getItem('token')
    const tenant = localStorage.getItem('selected-tenant')
    if (token && tenant && token.trim().length !== 0 && tenant.trim().length !== 0) {
      this.setState({ redirect: true })
    }
    this.setState({ loading: false })
    window.addEventListener('resize', this.handleWindowResize);
    this.handleWindowResize();
  }

  render() {
    const { content } = this.props;

    if (this.state.loading) {
      return <Spinner />
    }

    if (this.state.redirect) {
      return <Redirect to='/' />
    }

    return (
      <Authlayout className="h-100 auth-main-wrapper row overflow-y-auto">
        <Col className={`leftlogin-section ${this.state.isMediumScreen ? 'w-100' : 'w-50'}`}>
          <div className={`d-flex ${this.state.isMediumScreen ? 'justify-content-center img-margin-bottom' : 'flex-1'} items-center`}>
            <img className='top-img img-responsive' src={srcLogo} />
          </div>
          {
            this.state.isMediumScreen ?
              content
              : <div>
                <img className='bottom-img img-responsive' src="/images/new/Company-Tagline.png" />
              </div>
          }
        </Col>
        {
          !this.state.isMediumScreen && <Col md={6} className="rightlogin-section">
            {content}
          </Col>
        }
      </Authlayout>
    );
  }
}

AuthLayout.propTypes = propTypes;
AuthLayout.contextTypes = {
  __: PropTypes.func,
};

export default withRouter(AuthLayout);


// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/AuthLayout.js